import { Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import { featurePages } from '../data/featurePages';
import { useCasePages } from '../data/useCasePages';
import { useSiteLanguage } from '../i18n/siteLanguage';
import styles from './Footer.module.css';

const SALES_PHONE = '+306973391643';
const ADS_CALL_SEND_TO = 'AW-18049961352/qLt0COvag5IcEIib8p5D';

function StripeLogo() {
  return (
    <svg viewBox="0 0 60 25" width="60" height="25" aria-label="Stripe">
      <rect width="60" height="25" rx="4" fill="#635BFF" />
      <text x="30" y="17" textAnchor="middle" fontFamily="system-ui,sans-serif" fontWeight="700" fontSize="12" fill="#fff">stripe</text>
    </svg>
  );
}

function VivaLogo() {
  return (
    <svg viewBox="0 0 60 25" width="60" height="25" aria-label="Viva Wallet">
      <rect width="60" height="25" rx="4" fill="#1A1A2E" />
      <text x="30" y="17" textAnchor="middle" fontFamily="system-ui,sans-serif" fontWeight="700" fontSize="11" fill="#FF6B00">viva</text>
    </svg>
  );
}

function Footer() {
  const { language } = useSiteLanguage();
  const isGreek = language === 'el';
  const localizePath = (path) => (isGreek ? (path === '/' ? '/el' : `/el${path}`) : path);

  const reportCallConversion = (url) => {
    const callback = () => {
      if (typeof url !== 'undefined' && url) {
        window.location = url;
      }
    };

    if (!window.gtag) {
      callback();
      return false;
    }

    window.gtag('event', 'conversion', {
      send_to: ADS_CALL_SEND_TO,
      value: 1.0,
      currency: 'EUR',
      event_callback: callback,
    });
    return false;
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={`container ${styles.grid}`}>
          <div className={styles.brandCol}>
            <Link to={localizePath('/')} className={styles.logo}>
              <img src="/digitized-menu-logo.svg" alt="digitizedmenu.com" className={styles.logoImage} />
            </Link>
            <p className={styles.tagline}>
              {isGreek
                ? 'Η σύγχρονη πλατφόρμα για ψηφιακά μενού, QR ordering, διαχείριση τραπεζιών και analytics.'
                : 'The modern platform for digital restaurant menus, QR ordering, table management, and analytics. Trusted by restaurants, cafes, bars, and hotels.'}
            </p>
            <div className={styles.contactRow}>
              <a href="mailto:info@infinityweb.gr"><FiMail /> info@infinityweb.gr</a>
              <a
                href={`tel:${SALES_PHONE}`}
                onClick={(e) => {
                  e.preventDefault();
                  reportCallConversion(`tel:${SALES_PHONE}`);
                }}
              >
                +30 697 339 1643
              </a>
            </div>
          </div>

          <div className={styles.col}>
            <h3>{isGreek ? 'Προϊόν' : 'Product'}</h3>
            <Link to={localizePath('/features')}>{isGreek ? 'Όλες οι δυνατότητες' : 'All Features'}</Link>
            <Link to={localizePath('/pricing')}>{isGreek ? 'Τιμολόγηση' : 'Pricing'}</Link>
            <Link to={localizePath('/payment-options')}>{isGreek ? 'Τρόποι Πληρωμής' : 'Payment Options'}</Link>
            <Link to={localizePath('/faq')}>FAQ</Link>
            <Link to={localizePath('/contact')}>{isGreek ? 'Επικοινωνία' : 'Contact'}</Link>
            <Link to={localizePath('/register')}>{isGreek ? 'Ξεκινήστε Δωρεάν' : 'Get Started Free'}</Link>
          </div>

          <div className={styles.col}>
            <h3>{isGreek ? 'Δυνατότητες' : 'Features'}</h3>
            {featurePages.slice(0, 5).map((f) => (
              <Link key={f.slug} to={localizePath(`/features/${f.slug}`)}>{f.title}</Link>
            ))}
          </div>

          <div className={styles.col}>
            <h3>{isGreek ? 'Κλάδοι' : 'Use Cases'}</h3>
            {useCasePages.slice(0, 4).map((u) => (
              <Link key={u.slug} to={localizePath(`/use-cases/${u.slug}`)}>{u.title.replace('Digital Menus for ', '')}</Link>
            ))}
            <Link to={localizePath('/use-cases')}>{isGreek ? 'Προβολή Όλων' : 'View All'}</Link>
          </div>

          <div className={styles.col}>
            <h3>{isGreek ? 'Πόροι' : 'Resources'}</h3>
            <Link to={localizePath('/faq')}>{isGreek ? 'Κέντρο Βοήθειας' : 'Help Center'}</Link>
            <a href="mailto:info@infinityweb.gr">{isGreek ? 'Υποστήριξη Email' : 'Email Support'}</a>
            <Link to={localizePath('/login')}>{isGreek ? 'Σύνδεση' : 'Sign In'}</Link>
            <Link to={localizePath('/register')}>{isGreek ? 'Δημιουργία Λογαριασμού' : 'Create Account'}</Link>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={`container ${styles.bottomInner}`}>
          <p>
            &copy; {new Date().getFullYear()} digitizedmenu.com. {isGreek ? 'Με επιφύλαξη παντός δικαιώματος.' : 'All rights reserved.'}
          </p>
          <div className={styles.paymentIcons}>
            <Link to={localizePath('/payment-options')} title="Stripe" className={styles.paymentIcon}><StripeLogo /></Link>
            <Link to={localizePath('/payment-options')} title="Viva Wallet" className={styles.paymentIcon}><VivaLogo /></Link>
          </div>
          <div className={styles.bottomLinks}>
            <Link to={localizePath('/privacy')}>Privacy Policy</Link>
            <Link to={localizePath('/terms')}>{isGreek ? 'Όροι Χρήσης' : 'Terms of Use'}</Link>
            <Link to={localizePath('/cookies')}>{isGreek ? 'Πολιτική Cookies' : 'Cookies Policy'}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
